// extracted by mini-css-extract-plugin
export var emptyState = "_4q-d";
export var statCard = "_4q-c";
export var table = "_4q-0";
export var tableCell = "_4q-4";
export var tableCellClickable = "_4q-5 _4q-4";
export var tableCellDefault = "_4q-6 _4q-4";
export var tableCellEmpty = "_4q-8";
export var tableCellWithValue = "_4q-7";
export var tableContainer = "_4q-e";
export var tableHeaderWeight = "_4q-1";
export var tableHeaderZone = "_4q-2";
export var tableRowHeader = "_4q-3";
export var viewModeButton = "_4q-9";
export var viewModeButtonActive = "_4q-a _4q-9";
export var viewModeButtonInactive = "_4q-b _4q-9";